import React from 'react';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { Checkbox } from 'ui-components/components/checkbox';
import { noop } from 'ui-components/default-props/noop';
import { testId } from 'ui-components/services/testid-service';
import style from '../common.module.less';
import RemoveAllFiltersDropdownMenuItem from '../../../../components/remove-all-filters-dropdown-menu-item';

const isArgumentOptionChecked = (existingFilters, argumentOption) => {
  if (existingFilters.length === 0) {
    return false;
  }

  return existingFilters.some((filterObject) => {
    const { criterionArgumentValue } = filterObject;
    return criterionArgumentValue === argumentOption.value;
  });
};

export const FormChecklist = (criterionArgumentOptions, filterBy, existingFiltersHelpers) => {
  const { existingFilters, onApplyFilter, onRemoveFilter, removeAllOfTheseFilters } = existingFiltersHelpers;
  const hasExistingFilters = !!existingFilters.length;
  const onArgumentOptionToggled = (criterionArgument) => {
    // these are the values excluding the current toggle
    const existingCriterionArgumentValues = existingFilters.map((filterObject) => filterObject.criterionArgumentValue);
    const isAddingFilter = existingCriterionArgumentValues.indexOf(criterionArgument.value) === -1;
    if (isAddingFilter) {
      onApplyFilter(filterBy, undefined, criterionArgument);
      return;
    }

    const existingFilter = existingFilters.find((filter) => filter.criterionArgumentValue === criterionArgument.value);
    onRemoveFilter(existingFilter);
  };

  return (
    <div {...testId('filter-dropdown-menu-contents')}>
      <RemoveAllFiltersDropdownMenuItem hasExistingFilters={hasExistingFilters} onRemoveAllFiltersButtonClick={removeAllOfTheseFilters} />
      {criterionArgumentOptions.map((option, index) => (
        <DropdownMenuItem key={index} className={style['checklist-row']} onClick={() => onArgumentOptionToggled(option)}>
          <Checkbox checked={isArgumentOptionChecked(existingFilters, option)} label={option.displayName} onChange={noop} />
        </DropdownMenuItem>
      ))}
    </div>
  );
};
